import moment from 'moment';
import { useEffect, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { getStudentClassByDate } from '../../../api/campusClasses.api';
import {
  getCounsel,
  getStudentCounselMenu,
} from '../../../api/studentsCounsel.api';
import ErrorResponse from '../../../components/ErrorResponse';
import Loader from '../../../components/Loader';
import CounselForm from '../../../components/student/student/CounselForm';
import useAxios from '../../../hooks/useAxios';
import { IGetStudentClass } from '../../../models/campusClasses.model';
import {
  ICounselMenuResponse,
  IGetCounsel,
} from '../../../models/studentsCounsel.model';

interface IMatch {
  counselCode: string;
}

const StudentCounselDetail = () => {
  const match = useRouteMatch<IMatch>();
  const counselCode = Number(match.params.counselCode);
  const { data: res, isLoading, error, execute } = useAxios<ICounselMenuResponse>();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios<IGetCounsel>();
  const { data: res3, isLoading: isLoading3, error: error3, execute: execute3 } = useAxios<IGetStudentClass>();

  const [formMode, setFormMode] = useState('read');

  useEffect(() => {
    execute(getStudentCounselMenu());
  }, []);

  useEffect(() => {
    if (counselCode && res && !isLoading) {
      execute2(getCounsel(counselCode));
    }
  }, [counselCode, res, isLoading]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      execute3(
        getStudentClassByDate({
          srtDate: moment().format('YYYYMMDD'),
          memberCode: res2?.data?.studentMemberCode,
        }),
      );
    }
  }, [res2, isLoading2]);

  return (
    <div className="content scrollbar">
      {isLoading || isLoading2 || isLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />

      <div>
        <CounselForm
          formMode={formMode}
          setFormMode={setFormMode}
          counsel={res2?.data}
          menus={res?.data ?? []}
          studentInfo={res3?.data}
        />
      </div>
    </div>
  );
};

export default StudentCounselDetail;
